import { Wrapper } from "@Src/layout/Wrapper";
import { FormsPublicCreate } from "@Src/resources/forms_public/FormsPublicCreate";
import { FormsPublicShow } from "@Src/resources/forms_public/FormsPublicShow";
import { resourceName } from "@Src/resources/forms_public/name";
import type { Resource } from "@Src/resources/resources_config";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";

const resource: Resource = {
	create: Wrapper(resourceName.name, "create", FormsPublicCreate),
	show: Wrapper(resourceName.name, "show", FormsPublicShow),
	icon: DynamicFormIcon,
	name: resourceName.name,
	path: `/${resourceName.name}`,
	apiPath: "forms_public/forms_public",
};

export default resource;
